/**
 * @generated SignedSource<<cb5d595fd3b220ddf756c041b342b771>>
 * @relayHash 45791e70987160bc0ac43f13e779e5f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c9fba04873c32f46f0cc1be9c4f6620b0a4a2a48a65bcf319ef7ab118dc349bb

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LevelUpSettingsQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type LevelUpSettingsQuery$data = {
  readonly jira_projectByIdOrKey: {
    readonly created: AGG$DateTime | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"LevelUpSettingsSection">;
};
export type LevelUpSettingsQuery = {
  response: LevelUpSettingsQuery$data;
  variables: LevelUpSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "created"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LevelUpSettingsQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "LevelUpSettingsSection"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LevelUpSettingsQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      },
      {
        "args": [
          (v1/*: any*/)
        ],
        "concreteType": "CodeInJira",
        "kind": "LinkedField",
        "name": "codeInJira",
        "plural": false,
        "selections": [
          {
            "concreteType": "CodeInJiraUserConfiguration",
            "kind": "LinkedField",
            "name": "userConfiguration",
            "plural": false,
            "selections": [
              {
                "concreteType": "CodeInJiraBitbucketWorkspace",
                "kind": "LinkedField",
                "name": "ownedBitbucketWorkspaces",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "uuid"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c9fba04873c32f46f0cc1be9c4f6620b0a4a2a48a65bcf319ef7ab118dc349bb",
    "metadata": {},
    "name": "LevelUpSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "18a7ea314671a99e90c416937c5291cf";

export default node;
